module.exports = __webpack_public_path__ + "img/speaker-GogiGvakharia-imgs.d25eeab6.png";